import React from 'react';
import { styled, LazyImage, ThemeProps } from '@teko/ui';

export interface LogoLoadingProps {
  logo?: string;
}

const Wrapper = styled.div`
  width: 80px;
  height: 80px;
  position: relative;
`;

const Logo = styled(LazyImage)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const Spinner = styled.div<ThemeProps>(
  ({ theme }: ThemeProps) => `
    background: none;
    @keyframes ldio-yuapljtmof {
      0% {
        transform: rotate(0deg);
      }
      50% {
        transform: rotate(180deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
    .ldio-yuapljtmof  {
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      margin: auto;
      animation: ldio-yuapljtmof 1s linear infinite;
      width: 70px;
      height: 70px;
      border-radius: 50%;
      box-shadow: 0 2px 0 0 ${theme.brand.loading || '#1435c3'};
      box-sizing: content-box;
    }
`,
);

export const LogoLoading: React.FC<LogoLoadingProps> = ({
  logo = '',
  ...props
}: LogoLoadingProps) => {
  const size = 80;
  return (
    <Wrapper {...props}>
      {logo && <Logo width={size / 2} height={size / 2} src={logo} />}
      <Spinner>
        <div className="ldio-yuapljtmof"></div>
      </Spinner>
    </Wrapper>
  );
};
